import {Box, CssBaseline, Typography} from '@mui/material';
import Topbar from '../../layout/Topbar';
import SettingsSidebar from '../SettingsSidebar';
import React from 'react';
import PaymentMethod from './PaymentMethod';
import SubscriptionDetails from './SubscriptionDetails';
import Invoices from './Invoices';
import {SettingsContentBox, SettingsRoot} from '../General';
import {getSettingsColors} from '../SettingsDesign';

export const Subscription = props => <SettingsRoot>
    <CssBaseline/>
    <Topbar/>
    <SettingsSidebar {...props}/>
    <SettingsContentBox sx={{bgcolor: theme => getSettingsColors(theme).canvas}}>
        <Box sx={{maxWidth: 1280, mx: 'auto', px: {xs: 2, md: 4}, py: 3, minWidth: 0}}>
            <Box sx={{mb: 3}}>
                <Typography component="h1" sx={{fontSize: {xs: 24, md: 28}, fontWeight: 700, letterSpacing: '-0.5px'}}>Subscription</Typography>
                <Typography sx={{mt: 0.75, color: 'text.secondary', fontSize: 14, whiteSpace: 'normal'}}>Manage your plan, usage, billing details, and invoices.</Typography>
            </Box>
            <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', lg: 'minmax(0, 1.1fr) minmax(0, 1fr)'}, gap: 3, alignItems: 'start'}}>
                <SubscriptionDetails/>
                <Box sx={{display: 'grid', gap: 3, minWidth: 0}}><PaymentMethod/><Invoices/></Box>
            </Box>
        </Box>
    </SettingsContentBox>
</SettingsRoot>;
